
import sliderline from './imgs/sliderline.svg';
import slidercircle from './imgs/slidercircle.svg';
import React from 'react';
import Anime from 'react-anime';

class Checkbox extends React.Component {

constructor(props) {
    super(props);
    this.state = {
        activated: false
      };
  }

  componentDidMount() {
    
}

   
   activate = () => {
    this.setState({
        activated: true
    })
   }
 render(){
    let checkedthing;
    if(this.state.activated){
         checkedthing = this.props.checked
    }
    else{
         checkedthing = 'checked'
    }
    
  return (
   
     
    <input onClick={this.activate} onChange={this.props.onChange} checked={checkedthing} style={{ marginRight: '.7rem' }} className="form-check-input p-pointer" type="checkbox" value="" id={this.props.id}/>
      
  );
  }

}
export default Checkbox;